<template>
    <div>
        <div v-if="statuses.length">
            {{ statuses[0].registrationAuthority.name }}:
            <em>{{ statuses[0].stateName }}</em> on
            {{ getPrettyDate(statuses[0].registrationDate) }}
        </div>

        <div v-else>
            Unregistered
        </div>
    </div>
</template>

<script>
import {formatDate} from "src/lib/utils";

export default {
    name: "MetadataStatus",
    props: {
        statuses: {
            type: Array,
            required: true
        }
    },

    // This allow access to imported methods
    methods: {
        getPrettyDate(time) {
            return formatDate(time)
        },
    }
}
</script>
